import React from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'

import { Breadcrumbs, Link } from '@mui/material'

import {
  TextPopUp,
  StyledPopup,
} from '@components/table/beneficiaryList/styles'

import colors from '@settings/styleSettings'

import {
  Container, Content, Description, Title, TitleContainer
} from './styles'

const FilterBar = ({ pathname, cancel }) => {
  const { insurance } = useParams()

  const isReviewing = pathname.endsWith('revisar') || pathname.endsWith('concluir')
  const isConcluding = pathname.endsWith('concluir')

  return (
    <Container>
      <Content>
        <TitleContainer>
          <Title>Importar exames</Title>
          <StyledPopup
            trigger={() => (
              <div>
                <span
                  className="material-symbols-outlined"
                  style={{
                    color: colors.strongGray,
                    cursor: 'pointer',
                  }}
                >
                  help
                </span>
              </div>
            )}
            on={['hover', 'focus', 'click']}
            position="top"
            closeOnDocumentClick
          >
            <TextPopUp>
              Essa versão do sistema suporta a importação dos exames
              <br />
              PSA e hemograma em formato PDF gerados pelo sistema Jalis
            </TextPopUp>
          </StyledPopup>
        </TitleContainer>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link
            style={{ fontWeight: 'bold' }}
            underline="none"
            color={colors.primary}
            href={`/${insurance}/acompanhamento/importar-exames`}
          >
            Adicionar arquivos
          </Link>
          <Link
            style={{ pointerEvents: isReviewing || isConcluding ? '' : 'none', fontWeight: 'bold' }}
            color={
              isReviewing
                ? colors.primary
                : colors.strongGray
            }
            underline="none"
            href={`/${insurance}/acompanhamento/importar-exames/revisar`}
          >
            Revisar arquivos
          </Link>
          <Link
            style={{ pointerEvents: isConcluding ? '' : 'none', fontWeight: 'bold' }}
            color={
              isConcluding ? colors.primary : colors.strongGray
            }
            underline="none"
            href={`/${insurance}/acompanhamento/importar-exames/concluir`}
          >
            Concluir
          </Link>
        </Breadcrumbs>
        <Description>
          Adicione até 50 arquivos em PDF com tamanho máximo de 50MB
        </Description>
      </Content>
      <span
        className="material-symbols-outlined"
        style={{
          color: colors.strongGray,
          cursor: 'pointer',
          alignSelf: 'flex-start'
        }}
        onClick={cancel}
      >
        close
      </span>
    </Container>
  )
}

FilterBar.propTypes = {
  pathname: PropTypes.string,
  cancel: PropTypes.func.isRequired
}

FilterBar.defaultProps = {
  pathname: '',
}
export default FilterBar
